<template>
  <div class="">


<!--footer start-->

<footer class="footer">
  <div class="primary-footer">
    <div class="container">
      <div class="row mb-10 align-items-center">
        <div class="col-lg-8 col-md-7">
          <h2 class="title text-white">Let's Start Work With Agencio Today</h2>
        </div>
        <div class="col-lg-4 col-md-5 text-md-left mt-4 mt-md-0">
          <a class="btn btn-theme" href="#"><span>Get In Touch <i class="fas fa-plus-square"></i></span></a>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-lg-5 col-md-6">
          <div class="footer-logo mb-3">
            <a href="index.html"><img class="img-fluid" src="images/logo-white.png" alt=""></a>
          </div>
          <p class="mb-0">Agencio - Agency And Portfolio Template Is fully responsible, Build whatever you like with the Agencio, Agencio is the creative, modern HTML5 Template suitable for Your business.</p>
        </div>
        <div class="col-lg-6 mr-auto col-md-6 mt-5 mt-md-0">
          <h4 class="mb-4 text-white">Useful Link</h4>
          <div class="footer-list">
            <ul class="list-inline">
              <li><a href="index.html">Home</a>
              </li>
              <li><a href="about-us.html">About Us</a>
              </li>
              <li> <a href="blog-left-sidebar.html">Blog</a>
              </li>
              <li> <a href="team.html">Team</a>
              </li>
              <li> <a href="faq.html">Faq</a>
              </li>
              <li> <a href="portfolio-masonary.html">Portfolio</a>
              </li>
              <li> <a href="contact.html">Contact Us</a>
              </li>
              <li><a href="privacy-policy.html">Privacy Policy</a>
              </li>
              <li><a href="terms-and-conditions.html">Terms</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="secondary-footer">
    <div class="container">
      <div class="copyright">
        <div class="row align-items-center">
          <div class="col-lg-7 order-lg-1 text-lg-left"> <span>Copyright 2020 Agencio Theme by <u><a href="#">ThemeHt</a></u> | All Rights Reserved</span>
          </div>
          <div class="col-lg-5 mt-3 mt-lg-0">
            <div class="footer-social">
              <ul class="list-inline">
                <li><a href="#"><i class="fab fa-facebook-f"></i></a>
                </li>
                <li><a href="#"><i class="fab fa-dribbble"></i></a>
                </li>
                <li><a href="#"><i class="fab fa-skype"></i></a>
                </li>
                <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
                </li>
                <li><a href="#"><i class="fab fa-youtube"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="dot-bg">
    <img class="img-fluid" src="images/pattern/05.png" alt="">
  </div>
</footer>

<!--footer end-->

<div class="burger-menu"><span class="menu-toggle"></span>
</div>
<nav class="menu-2">
  <div class="media-info">    
    <div class="contact-info">
      <h4 class="text-white mb-4">contact us</h4>
          <div class="contact-media mb-4"> <i class="flaticon-location"></i>
            <h6>Address:</h6>
            <span>423B, Road Wordwide Country, USA</span>
          </div>
          <div class="contact-media mb-4"> <i class="flaticon-email"></i>
            <h6>Email Us</h6>
            <a href="mailto:themeht23@gmail.com"> themeht23@gmail.com</a>
          </div>
          <div class="contact-media"> <i class="flaticon-support-1"></i>
            <h6>Call Us</h6>
            <a href="tel:+912345678900">+91-234-567-8900</a>
          </div>
        </div>
        <div class="hero-social mt-5">
          <h4 class="text-white mb-4">Follow Us</h4>
      <ul class="list-unstyled">
        <li class="mr-2">
          <a href="#"> <i class="fab fa-facebook-f"></i>
          </a>
        </li>
        <li class="mr-2">
          <a href="#"> <i class="fab fa-dribbble"></i>
          </a>
        </li>
        <li class="mr-2">
          <a href="#"> <i class="fab fa-skype"></i>
          </a>
        </li>
        <li>
          <a href="#"> <i class="fab fa-linkedin-in"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>

<!--back-to-top start-->

<div class="scroll-top"><a class="smoothscroll" href="#top"><i class="fas fa-chevron-up"></i></a></div>

<!--back-to-top end-->

  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
